<template>
  <div>
    <card
      class="player-card"
      :bodyClasses="['body', {'closed': !expanded}]"
      shadow
    >
      <div slot="header" class="row">
        <div class="col-auto d-flex align-items-center" @click="expanded = !expanded">
          <a href="#!" class="avatar rounded-circle">
            <img alt="Image placeholder" :src="getAvatarUrl(profile.user)">
          </a>
        </div>
        <div class="col d-flex align-items-center" @click="expanded = !expanded">
          <h3 class="mb-0">{{profile.user.Name}}</h3>
          <badge :type="status.type" class="status-badge">{{status.text}}</badge>
          <badge type="warning" class="status-badge" v-if="missingESC">ESC MISSING</badge>
        </div>
        <div class="col-auto text-right d-flex align-items-center justify-content-end">
          <div class="button-area"  v-if="!loading">
            <base-button
              type="danger"
              size="sm"
              @click="discard"
              v-if="status.text === 'UNSAVED'"
            >
              Discard
            </base-button>
            <base-button
              type="success"
              size="sm"
              @click="save"
              v-if="status.text === 'UNSAVED'"
            >
              Save
            </base-button>

          </div>
          <div class="loader" v-if="loading">
            Loading
            <i class="fa fa-spinner fa-spin"></i>
          </div>
          <i class="fa fa-chevron-down" v-if="!expanded" @click="expanded = !expanded"/>
          <i class="fa fa-chevron-up" v-else @click="expanded = !expanded"/>
        </div>
      </div>

      <div class="row align-items-end d-flex">
        <div class="col-lg-4 col-md-6">
          <base-input
            class="mb-0"
            label="Gross"
            v-model="model.gross"
            input-classes="form-control-alternative"
            type="number"
          />
        </div>
        <div class="col-lg-4 col-md-6">
          <base-input
            class="mb-0"
            label="Equitable Stroke Score"
            v-model="model.eqScore"
            input-classes="form-control-alternative"
            type="number"
          />
        </div>

        <div class="col-lg-3 col-md-6 col-8">
          <base-input
            class="mb-0"
            label="Longest Drive"
            v-model="model.long_drive"
            input-classes="form-control-alternative"
            type="number"
            :disabled="model.missLD"
            v-if="league.showLD"
          />
        </div>
        <div class="col-lg-1 col-md-6 col-4">
          <base-checkbox
            class="mb-2 checkbox-short"
            v-model="model.missLD"
            v-if="league.showLD"
          >
            Miss
          </base-checkbox>
        </div>
        <div class="col-lg-3 col-md-6 col-8">
          <base-input
            class="mb-0"
            label="Closest to Pin"
            v-model="model.closest_to_pin"
            input-classes="form-control-alternative"
            type="number"
            :disabled="model.missCTP"
            v-if="league.showCTP"
          />
        </div>
        <div class="col-lg-1 col-md-6 col-4">
          <base-checkbox
            class="mb-2 checkbox-short"
            v-model="model.missCTP"
            v-if="league.showCTP"
          >
            Miss
          </base-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <base-input
            label="Note"
            class="mb-0 mt-1"
            input-classes="form-control-alternative"
            v-model="model.note"
          />
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import ErrorHandler from '@/helpers/AuthError';
import AvatarHelper from '@/helpers/Avatars';

export default {
  name: 'PlayerScoreCard',
  props: {
    profile: {
      type: Object,
    },
    week: {
      type: Object,
    },
    league: {
      type: Object,
    },
  },
  data() {
    return {
      expanded: false,
      model: {
        gross: '',
        eqScore: '',
        long_drive: '',
        closest_to_pin: '',
        note: '',
        missCTP: false,
        missLD: false,
      },
      originalState: {
        gross: '',
        eqScore: '',
        long_drive: '',
        closest_to_pin: '',
        note: '',
        missCTP: false,
        missLD: false,
      },
      loading: false,
    };
  },
  mounted() {
    this.setOriginalState();
    this.setModelToScorecard();
  },
  watch: {
    originalScorecard() {
      if (!this.editing) {
        this.setOriginalState();
        this.setModelToScorecard();
      }
    },
  },
  computed: {
    editing() {
      if (
        this.model.gross !== this.originalState.gross
        || this.model.eqScore !== this.originalState.eqScore
        || this.model.long_drive !== this.originalState.long_drive
        || this.model.closest_to_pin !== this.originalState.closest_to_pin
        || this.model.note !== this.originalState.note
        || this.model.missCTP !== this.originalState.missCTP
        || this.model.missLD !== this.originalState.missLD
      ) {
        return true;
      }
      return false;
    },
    originalScorecard() {
      let scorecard = null;
      if (this.week !== null) {
        this.profile.scorecards.forEach((card) => {
          if (card.week === this.week.id) {
            scorecard = card;
          }
        });
      }
      return scorecard;
    },
    status() {
      if (this.editing) {
        return {
          text: 'UNSAVED',
          type: 'warning',
        };
      }
      if (
        this.originalScorecard === null
        && (this.model.gross === '' || this.model.gross <= 0)
        && (!this.model.missLD || this.model.long_drive === '' || this.model.long_drive <= 0)
        && (!this.model.missCTP || this.model.closest_to_pin === '' || this.model.closest_to_pin <= 0)
      ) {
        return {
          text: 'NO SCORE',
          type: 'secondary',
        };
      }
      if (
        this.model.gross === ''
        || this.model.gross === null
        || (!this.model.missLD
        && (this.model.long_drive === ''
        || this.model.long_drive === null))
        || (!this.model.missCTP
        && (this.model.closest_to_pin === ''
        || this.model.closest_to_pin === null))
      ) {
        return {
          text: 'PARTIALLY COMPLETE',
          type: 'info',
        };
      }
      return {
        text: 'COMPLETE',
        type: 'success',
      };
    },
    missingESC() {
      if (this.model.eqScore === '') {
        return true;
      }
      return false;
    }
  },
  methods: {
    createNewScorecard() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const newScorecard = {
        week: this.week.id,
        profile: this.profile.id,
        gross: this.model.gross !== '' ? this.model.gross : null,
        eqScore: this.model.eqScore !== '' ? this.model.eqScore : null,
        long_drive: this.model.long_drive !== '' ? this.model.long_drive : null,
        closest_to_pin: this.model.closest_to_pin !== '' ? this.model.closest_to_pin : null,
        note: this.model.note,
        missCTP: this.model.missCTP,
        missLD: this.model.missLD,
      };
      if (this.model.missCTP) {
        newScorecard.closest_to_pin = -1;
      }
      if (this.model.missLD) {
        newScorecard.long_drive = -1;
      }

      this.axios
        .post('/scorecards', newScorecard, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(() => {
          this.originalState.closest_to_pin = this.model.closest_to_pin;
          this.originalState.long_drive = this.model.long_drive;
          this.originalState.note = this.model.note;
          this.originalState.gross = this.model.gross;
          this.originalState.eqScore = this.model.eqScore;
          this.originalState.missCTP = this.model.missCTP;
          this.originalState.missLD = this.model.missLD;

          if (this.model.missCTP) {
            this.model.closest_to_pin = null;
            this.originalState.closest_to_pin = null;
          }
          if (this.model.missLD) {
            this.model.long_drive = null;
            this.originalState.long_drive = null;
          }
          this.$emit('saved');
          this.loading = false;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
          window.location.reload();
        });
    },
    updateExistingScorecard() {
      if (this.loading) {
        return;
      }
      this.loading = true;

      const newScorecard = {
        gross: this.model.gross !== '' ? this.model.gross : null,
        eqScore: this.model.eqScore !== '' ? this.model.eqScore : null,
        long_drive: this.model.long_drive !== '' ? this.model.long_drive : null,
        closest_to_pin: this.model.closest_to_pin !== '' ? this.model.closest_to_pin : null,
        note: this.model.note,
      };
      if (this.model.missCTP) {
        newScorecard.closest_to_pin = -1;
      }
      if (this.model.missLD) {
        newScorecard.long_drive = -1;
      }

      this.axios
        .put(`/scorecards/${this.originalScorecard.id}`, newScorecard, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(() => {
          this.originalState.closest_to_pin = this.model.closest_to_pin;
          this.originalState.long_drive = this.model.long_drive;
          this.originalState.note = this.model.note;
          this.originalState.gross = this.model.gross;
          this.originalState.eqScore = this.model.eqScore;
          this.originalState.missCTP = this.model.missCTP;
          this.originalState.missLD = this.model.missLD;

          if (this.model.missCTP) {
            this.model.closest_to_pin = null;
            this.originalState.closest_to_pin = null;
          }
          if (this.model.missLD) {
            this.model.long_drive = null;
            this.originalState.long_drive = null;
          }
          this.$emit('saved');
          this.loading = false;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
          window.location.reload();
        });
    },
    save() {
      if (this.originalScorecard !== null) {
        this.updateExistingScorecard();
      } else {
        this.createNewScorecard();
      }
    },
    discard() {
      this.model.gross = this.originalState.gross;
      this.model.eqScore = this.originalState.eqScore;
      this.model.long_drive = this.originalState.long_drive !== -1
        ? this.originalState.long_drive : null;
      this.model.closest_to_pin = this.originalState.closest_to_pin !== -1
        ? this.originalState.closest_to_pin : null;
      this.model.missCTP = this.originalState.closest_to_pin === -1;
      this.model.missLD = this.originalState.long_drive === -1;
      this.model.note = this.originalState.note;
    },
    getAvatarUrl(user) {
      return AvatarHelper.getAvatar(user);
    },
    setModelToScorecard() {
      if (this.originalScorecard !== null) {
        this.model.gross = this.originalScorecard.gross;
        this.model.eqScore = this.originalScorecard.eqScore;
        this.model.long_drive = this.originalScorecard.long_drive;
        this.model.closest_to_pin = this.originalScorecard.closest_to_pin;
        this.model.note = this.originalScorecard.note;
        this.model.missCTP = false;
        this.model.missLD = false;

        if (this.originalScorecard.closest_to_pin === -1) {
          this.model.missCTP = true;
          this.model.closest_to_pin = null;
        }
        if (this.originalScorecard.long_drive === -1) {
          this.model.missLD = true;
          this.model.long_drive = null;
        }
      } else {
        this.model.gross = '';
        this.model.eqScore = '';
        this.model.long_drive = '';
        this.model.closest_to_pin = '';
        this.model.note = '';
        this.model.missCTP = false;
        this.model.missLD = false;
      }
    },
    setOriginalState() {
      if (this.originalScorecard !== null) {
        this.originalState.gross = this.originalScorecard.gross;
        this.originalState.eqScore = this.originalScorecard.eqScore;
        this.originalState.long_drive = this.originalScorecard.long_drive;
        this.originalState.closest_to_pin = this.originalScorecard.closest_to_pin;
        this.originalState.note = this.originalScorecard.note;
        this.originalState.missCTP = false;
        this.originalState.missLD = false;

        if (this.originalScorecard.closest_to_pin === -1) {
          this.originalState.missCTP = true;
          this.originalState.closest_to_pin = null;
        }
        if (this.originalScorecard.long_drive === -1) {
          this.originalState.missLD = true;
          this.originalState.long_drive = null;
        }
      } else {
        this.originalState.gross = '';
        this.originalState.eqScore = '';
        this.originalState.long_drive = '';
        this.originalState.closest_to_pin = '';
        this.originalState.note = '';
        this.originalState.missCTP = false;
        this.originalState.missLD = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .loader{
    text-transform: uppercase;
    font-size: .9rem;
    font-weight: 600;
    opacity: .6;
    padding-right: .5rem;
  }
  .avatar {
    width: 40px;
    height: 40px;
  }
  .avatar img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .player-card{
    overflow: hidden;
  }
  .status-badge{
    margin-left: 1rem;
    margin-top: .2rem;
  }
  .button-area{
    margin-right: 1rem;
  }
</style>
<style lang="scss">
  .body{
    transition: all .15s;
  }
  .closed{
    height: 0;
    opacity: 0;
    visibility: none;
    padding: 0;
  }

  .checkbox-short{
    padding-left: 2rem;

    .custom-control-label::before{
      left: -2rem;
    }
    .custom-control-label::after{
      left: -2rem;
    }
  }
</style>
